import {useState} from 'react';
import styled from 'styled-components';
import {panelistaPrimaryColor} from 'src/utils/constants';
import RemixIcon from 'src/components/RemixIcon';

const compactThreshold = 900;

const ContentContainer = styled.div`
  margin-bottom: 24px;
  font-size: 18px;

  h3,
  strong {
    font-weight: 600;
  }

  p {
    white-space: pre-wrap;
    line-height: 1.7;
  }

  h2 {
    font-size: 28px;
    margin-top: 16px;
    margin-bottom: 12px;
  }

  img {
    max-width: 375px;
    width: 100%;
    display: block;
    margin: 24px auto;
    box-shadow: 0 1px 16px 0 rgba(0, 0, 0, 0.1);
  }

  ol,
  ul {
    list-style: initial;
  }

  ul li {
    margin-bottom: 8px;
  }
`;

const FAQItem = styled.div<{isActive: boolean}>`
  border: none;
  background-color: transparent;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: normal;
  text-align: left;
  border-bottom: 1px solid rgb(0, 0, 0, 0.1);
  flex-direction: column;

  p {
    color: ${(props) => (props.isActive ? panelistaPrimaryColor : 'var(--dark-text)')};
  }

  &:hover p {
    color: ${panelistaPrimaryColor};
  }

  & > span {
    font-size: 20px;
    margin-top: 8px;
  }

  & svg {
    transform: rotate(${(props) => (props.isActive ? '180deg' : '0deg')});
  }
`;

const ArticleTitleRow = styled.button`
  border: none;
  background-color: transparent;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  font-weight: normal;
  text-align: left;
`;

const ListText = styled.p`
  font-family: var(--font-jakarta);
  font-weight: 700;
  font-size: 20px;
  padding: 12px 0;
  margin-right: 16px;
  transition: color 0.2s;

  @media (max-width: ${compactThreshold}px) {
    font-size: 16px;
    padding: 0;
  }
`;

const ExpandCircle = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background: rgba(29, 146, 153, 0.1);
`;

const InlineContentContainer = styled(ContentContainer)`
  color: var(--dark-text);
  font-size: 18px;
  padding: 16px 0;
  text-align: left;
  line-height: 150%;

  > a {
    color: ${panelistaPrimaryColor};
  }

  @media (max-width: ${compactThreshold}px) {
    font-size: 16px;
    padding: 0;
  }
`;

type Props = {
  article: {title: string; body?: string; image?: React.ReactNode};
};

const DataProtectionFAQItem = ({article}: Props) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  return (
    <FAQItem isActive={isExpanded}>
      <ArticleTitleRow onClick={() => setIsExpanded(!isExpanded)}>
        <ListText>{article.title}</ListText>
        <ExpandCircle>
          <RemixIcon name="arrow-down-s-line" color="#54C7CD" />
        </ExpandCircle>
      </ArticleTitleRow>

      {isExpanded && article.body ? <InlineContentContainer dangerouslySetInnerHTML={{__html: article.body}} /> : null}

      {isExpanded && article.image ? (
        <InlineContentContainer style={{marginTop: 24}}>{article.image}</InlineContentContainer>
      ) : null}
    </FAQItem>
  );
};

export default DataProtectionFAQItem;
